// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__R70Xy"};